import { render, staticRenderFns } from "./TicketPurchase.vue?vue&type=template&id=b89c1dd6&scoped=true&"
import script from "./TicketPurchase.vue?vue&type=script&lang=js&"
export * from "./TicketPurchase.vue?vue&type=script&lang=js&"
import style0 from "./TicketPurchase.vue?vue&type=style&index=0&id=b89c1dd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89c1dd6",
  null
  
)

export default component.exports